import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { Calendar } from "primereact/calendar";

const FundTransferCreate = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    date: new Date(),
  });
  const [error, setError] = useState({});
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Http.get("/accounts/banks")
      .then((res) => {
        setBanks(res.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleDateChange = (e) => {
    setInputs((values) => ({ ...values, date: e.value }));
  };

  const formSubmit = async () => {
    try {
      // Map frontend field names to match backend expectations
      const submitData = {
        from_account_id: inputs.from_account_id,
        to_account_id: inputs.to_account_id,
        date: inputs.date,
        amount: inputs.amount,
        description: inputs.description,
        reference: inputs.reference
      };
      
      const res = await Http.post("/accounts/fund-transfers", submitData);
      navigate("/fund-transfer", {
        state: { message: res.data.message, type: "success" },
      });
    } catch (e) {
      setError(e.response.data.errors);
    }
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Fund Transfer</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Transfer Information</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            <div className="row">
              <div className="col-lg">
                <label>Date <span className="text-danger">*</span></label>
                <Calendar
                  value={inputs.date}
                  onChange={handleDateChange}
                  dateFormat="dd/mm/yy"
                  className="w-100"
                />
              </div>
              <div className="col-lg">
                <label>Reference</label>
                <input
                  type="text"
                  className="form-control"
                  name="reference"
                  value={inputs.reference || ""}
                  onChange={handleChange}
                  placeholder="Enter Reference"
                />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>From Account <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="from_account_id"
                  value={inputs.from_account_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select From Account</option>
                  {banks.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg">
                <label>To Account <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="to_account_id"
                  value={inputs.to_account_id || ""}
                  onChange={handleChange}
                >
                  <option value="">Select To Account</option>
                  {banks.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>Amount <span className="text-danger">*</span></label>
                <input
                  type="number"
                  className="form-control"
                  name="amount"
                  value={inputs.amount || ""}
                  onChange={handleChange}
                  placeholder="Enter Amount"
                />
              </div>
              <div className="col-lg">
                <label>Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  value={inputs.description || ""}
                  onChange={handleChange}
                  placeholder="Enter Description"
                  rows="3"
                ></textarea>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-3">
                <button
                  className="btn btn-primary btn-block mg-b-10"
                  onClick={formSubmit}
                >
                  <i className="fa fa-save mg-r-10"></i> Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundTransferCreate;